<template>
    <el-dialog
        title="说话配置"
        :visible.sync="dialogVisible"
        :append-to-body="true"
        :close-on-click-modal="false"
        width="532px"
        :before-close="handleClose">
        <div>
            <ElementForm
                ref="form"
                :form.sync="newForm"
                @onAttr="onAttr"
                @onEvent="onEvent"
            />
            <Roles
                v-if="isXunfei"
                ref="roles"
                :is-file-name="true"
                :visible.sync="isXunfei"
                :selectRole.sync="selectRole"
                :defaultValue="config"
                @onXunfei="onXunfei"
            />
            <LuyinBtn
                ref="record"
                style="width:0px;height: 0px;overflow: hidden;"
                @onLuyinBtn="onLuyinBtn"
            />
            <Form
                v-if="isAddAudio"
                type="audio"
                :visible.sync="isAddAudio"
                :isPlat.sync="isPlat"
                @success="formSuccess"
            />
            <More
                :visible.sync="isSelectAudio"
                type="audio"
                :isAuto="false"
                @onSelect="onSelect"
            />
            <Ma2
                v-if="isMa2"
                :visible.sync="isMa2"
                :url.sync="ma2Url"
                @onMa2="onMa2"
            />
            <!-- <div>
                <el-button @click="handleVoiceTry">试听</el-button>
            </div> -->
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="handleClose">取 消</el-button>
            <el-button type="primary" @click="submit">确 定</el-button>
          </span>
    </el-dialog>
</template>

<script>
    import BMF from 'browser-md5-file'
    import LuyinBtn from '../../views/main/components/types/components/common/components/luyinBtn'
    import Roles from './components/roles'
    import {fields} from './fields'
    import {fieldsRecord} from './fieldsRecord'
    import {fieldsImport} from './fieldsImport'
    import {AudioPlay, Word2VoiceUrl, AudioAllTime, AudioPause} from "../../utils/audio";
    import {upLoad, getFileStream} from '../../utils/upload'
    import * as commonServer from '../../api/common'
    import * as GlobalServer from '../../api/global'
    import Form from '../../views/main/components/types/components/common/components/uploadBtn/components/form'
    import More from '../../views/main/components/types/components/more'
    import Ma2 from './components/ma2'
    import Config from '../../config/app'

    export default {
        name: "voice-config",
        components: {
            LuyinBtn,
            Roles,
            Form,
            More,
            Ma2
        },
        props: {
            type: String,
            form: Array,
            visible: {
                type: Boolean,
                default: true
            },
            defaultValue: Object
        },
        computed: {
            isPlat () {
                return this.$store.state.isShop
            },
            addResource(){
                return this.isPlat?'addResourceShop':'addResource'
            },
        },
        watch:{
            visible(vl){this.dialogVisible = vl},
            dialogVisible(vl){
                this.$emit('update:visible', vl)

                // 暂停音乐
                AudioPause()
            },
            defaultValue: {
                handler(vl) {
                    this.newDefaultValue = vl
                },
                deep: true,
                immediate: true
            },
            newDefaultValue(vl){this.$emit('update:defaultValue', vl)},
            form(vl){this.newForm = vl},
            newForm(vl){this.$emit('update:form', vl)}
        },
        mounted() {
            this.$nextTick(()=>{
                this.init()
            })
        },
        data(){
            return {
                isAddAudio: false,
                isSelectAudio: false,
                isMa2: false,
                ma2Url: '',
                initial: false,
                dialogVisible: this.visible,
                newDefaultValue: this.defaultValue,
                newForm: this.$_.cloneDeepWith(fields),

                isXunfei: false,
                selectRole: 0,
                config: {
                    text: ''
                },
                audioUrl: '' // 音频地址
            }
        },
        methods: {
            async init(){
                this.initial = true
                if(Object.keys(this.newDefaultValue).length>0) {
                    if (this.newDefaultValue.h5_config && this.newDefaultValue.h5_config.type) {
                        this.getCurFields(this.newDefaultValue.h5_config.type)
                    }
                    // 存在历史数据
                    let data2 = this.$_.cloneDeepWith(this.newForm)

                    // 如果显示文本框为true
                    if (this.newDefaultValue.h5_config && this.newDefaultValue.h5_config.isShow) {
                        data2.push(this.pictureUrl())
                        data2.push(this.isText())
                    }

                    // 音频地址存在历史数据
                    if (this.newDefaultValue.audioUrl) this.audioUrl = this.newDefaultValue.audioUrl

                    data2.map(v => {
                        if (this.newDefaultValue.h5_config && this.newDefaultValue.h5_config[v.attr]) {
                            v.value = this.newDefaultValue.h5_config[v.attr]
                        }
                    })
                    this.newForm = data2
                    // console.log(this.newForm)
                    // debugger
                    let data = this.newDefaultValue
                    this.config = data && data.h5_config ? data.h5_config.voice_config:{text:''}

                    let typeIndex = this.$utils.getIndexByAttr({attr: 'type', data: this.newForm})
                    if(!this.newForm[typeIndex].value){
                        this.newForm[typeIndex].value = '1'
                    }
                }
                setTimeout(()=>{
                    this.initial = false
                },300)
            },
            //
            onMa2 ({url, name}) {
                console.log('扫码回调==>', url)
                this.audioUrl = url
                let voiceIndex = this.$utils.getIndexByAttr({attr: 'voice', data: this.newForm})
                this.newForm[voiceIndex].value = name || '微信录音'
            },
            onSelect(item){
                console.log('音频选中==>', item)
                this.setCurSelect(item)
            },
            async formSuccess(id){
                console.log('上传音频成功id==>', id)
                let getResourceDetail = this.$store.getters.isPlat ? 'getResourceShopDetail' : 'getResourceDetail'
                const detail = await commonServer.default[getResourceDetail]({
                    id,
                    clientsId: this.$store.state.initConfig.school_id
                })
                console.log('获取音频详情==>', detail)
                // 根据音频id 获取当前音频地址
                this.setCurSelect(detail.data)
            },
            // 设置当前选中的音频地址及音频名称
            setCurSelect(data){
                let selectIndex = this.$utils.getIndexByAttr({attr: 'voice', data: this.newForm})
                this.newForm[selectIndex].value = data.name
                this.audioUrl = data.attributes.resources.url
            },
            onLuyinBtn(obj){
                console.log('录音==>', obj)

                // 上传服务器
                upLoad({
                    fileName: obj.name + '.wav',
                    file: obj.row,
                    callback: async (res)=>{
                        try {
                            // 上传音频文件
                            let addResource = obj.isShop?'addResourceShop':'addResource'
                            const result = await commonServer.default[addResource]({
                                ...obj,
                                clientsId: this.$store.state.initConfig.school_id,
                                sort:'audio',
                                attributes: {
                                    type: 'flash',
                                    cover: 'default.jpg',
                                    remotepath: res.split('.com/')[1],
                                    md5: res.split('.com/')[1].replace('.wav', '')
                                }
                            })
                            if(result.data.id){
                                // 如果创建成功 获取详情中的音频地址
                                this.formSuccess(result.data.id)
                                this.$refs.record && this.$refs.record.handleClickDestroy()

                                // let getResourceDetail = obj.isShop?'getResourceShopDetail':'getResourceDetail'
                                // const detail = await commonServer.default[getResourceDetail]({
                                //     id: result.data.id,
                                //     clientsId: this.$store.state.initConfig.school_id,
                                // })
                                // console.log('音频详情==>', detail)
                                // let selectIndex = this.$utils.getIndexByAttr({attr: 'voice', data: this.newForm})
                                // this.newForm[selectIndex].value = detail.data.name
                                // this.audioUrl = detail.data.attributes.resources.url

                            }
                        }catch (e) {
                            // this.$message.error('上传音频失败')
                        }
                    }
                })

            },
            handleClose() {
                this.dialogVisible = false
            },
            async submit() {
                let state = this.$refs.form.validateForm()
                if(state){
                    // TODO 获取讯飞真实转换语音
                    let text = this.$utils.getObjByAttr({attr: 'text', data: this.newForm}).value
                    let pictureUrlIndex = this.$utils.getIndexByAttr({attr: 'pictureUrl', data: this.newForm})
                    let index = this.$utils.getIndexByAttr({attr: 'text', data: this.newForm})
                    let config =  this.$utils.getObjByArr({data: this.newForm})
                    let obj = {
                        h5_config: {...config, voice_config: this.config},
                        type: 'dialog',
                        text,
                        isText: this.$utils.getObjByAttr({attr: 'isText', data: this.newForm}).value,
                        audioUrl: Word2VoiceUrl({...this.config, text: this.newForm[index].value}),
                    }
                    // 如果当前类型非智能录音 则走音频地址
                    if(`${this.newForm[0].value}` === '1'){
                        let work=this.textToTTS(this.newForm[index].value);
                        const res = await GlobalServer.getVoiceByAliyun({
                            work: work,
                            voice: this.config.per,
                            volume: this.config.vol,
                            speech_rate: this.config.spd
                        })
                        obj.audioUrl = res.url
                    } else {
                        obj.audioUrl = this.audioUrl
                    }
                    if(pictureUrlIndex>-1){
                        obj.pictureUrl = this.$utils.getObjByAttr({attr: 'pictureUrl', data: this.newForm}).value
                    }

                    // 获取音频时长
                    // 播放一次音频，并获取音频长
                    AudioPlay({url: obj.audioUrl})
                    AudioAllTime((duration)=>{
                        console.log('向cocos发出111==>', {duration:duration.seconds, ...obj})
                        this.$emit('onVoiceConfig', {duration: duration.seconds, ...obj})
                        this.handleClose()
                    })
                }
            },
            onAttr(data){
                if (this.initial) {
                    return false
                }
                console.log('attr==>', data)
                switch (data.attr) {
                    case 'type': {
                        let typeIndex = this.$utils.getIndexByAttr({attr: 'type', data: this.newForm})
                        this.getCurFields(this.newForm[typeIndex].value, true)
                        break
                    }
                    case 'text': {
                        let textIndex = this.$utils.getIndexByAttr({attr: 'text', data: this.newForm})
                        this.config.text = this.newForm[textIndex].value
                        break
                    }
                    case 'select': {
                        // 说话选择，唤醒角色选择
                        // this.isXunfei = true
                        // let index = this.$utils.getIndexByAttr({attr: 'select', data: this.newForm})
                        // this.newForm[index].options.map((v, i) => {
                        //     if (v.key === this.newForm[index].value) {
                        //         this.selectRole = i
                        //     }
                        // })
                        break
                    }
                    case 'isShow': {
                        let obj = this.$utils.getObjByAttr({attr: 'isShow', data: this.newForm})
                        if (obj.value) {
                            this.showUpload()
                        } else {
                            this.closeUpload()
                        }
                        break
                    }
                    default:
                }
            },
            onEvent(data, type) {
                console.log('onEvent', data, type)
                switch(`${data.attr}|${type}`){
                    case 'text|btn':
                        this.handleVoiceTry()
                        break
                    case 'select|edit':{
                        // 只有文本有内容才允许选择语音合成
                        let textIndex = this.$utils.getIndexByAttr({attr: 'text', data: this.newForm})
                        if(!this.newForm[textIndex].value){
                            this.$message.error('请先输入说话文本')
                            return false
                        }
                        // 说话选择，唤醒角色选择
                        this.isXunfei = true
                        let index = this.$utils.getIndexByAttr({attr: 'select', data: this.newForm})
                        this.newForm[index].options.map((v, i) => {
                            if (v.key === this.newForm[index].value) {
                                this.selectRole = i
                            }
                        })
                        break
                    }
                    case 'voice|edit':{
                        // 播放音频
                        this.audioUrl && AudioPlay({url: this.audioUrl})
                        break
                    }
                    case 'btns|html':
                        // 网页录制
                        this.$refs.record && this.$refs.record.showLuyin()
                        break
                    case 'btns|weixin': {
                        // 获取录音页面二维码
                        // let arr = window.location.href.split('?')
                        let audioName = `weixin_${new Date().getFullYear()}${new Date().getMonth()+1}${new Date().getDate()}${new Date().getMilliseconds()}`
                        // this.ma2Url = `${Config.wx_web}?${arr[1]}&audioName=${audioName}`
                        this.ma2Url = `${Config.wx_web}?id=${this.$route.query.id}&category_id=${this.$route.query.category_id}&school_id=${this.$route.query.school_id}&audioName=${audioName}`
                        this.isMa2 = true
                        // TODO 微信录制 每2秒轮询一次录音文件是否存在，
                        // 如果存在则使用,超过15分钟还没上传表示上传超时 - 关闭当前二维码页面
                        // 否则获取成功，走正常业务

                        break
                    }
                    case 'btns|local':
                        // 本地上传
                        this.isAddAudio = true
                        break
                    case 'btns|select':
                        this.isSelectAudio = true
                        // 素材库选择
                        break
                }
            },
            percent2percent25(URI){
                if(URI.indexOf('%') > -1) {
                    return URI.replace(/%/g,'%25')
                }else{
                    return URI;
                }
            },
            // 获取当前选择的类别
            getCurFields(typeIndex){
                if (typeIndex) {
                    console.log('当前类别index==>', typeIndex)
                    let form = null
                    switch (`${typeIndex}`) {
                        case '1':
                            form = this.$_.cloneDeepWith(fields)
                            break
                        case '2':
                            form = this.$_.cloneDeepWith(fieldsRecord)
                            break
                        case '3':
                            form = this.$_.cloneDeepWith(fieldsImport)
                            break
                    }
                    form[0].value = `${typeIndex}`
                    this.newForm = form
                }
            },
            pictureUrl () {
                let value = this.newDefaultValue.h5_config && this.newDefaultValue.h5_config.pictureUrl || ''
                return {
                    attr: 'pictureUrl',
                    "name": "文本框选择",
                    value,
                    "type": "SelectImage",
                    "props": {
                        "rules": {
                            "required": false,
                            "message": "请选择",
                            "target": "blur"
                        }
                    },
                    "status": "1"
                }
            },
            isText(){
                return {
                    attr: 'isText',
                    "name": "仅显示文字",
                    "value": false,
                    "type": "Switch",
                    "props": {
                        "rules": {
                            "required": false,
                            "message": "请选择"
                        }
                    }
                }
            },
            showUpload(){
                this.newForm.push(this.pictureUrl())
                this.newForm.push(this.isText())
            },
            closeUpload(){
                let index = this.$utils.getIndexByAttr({attr:'pictureUrl', data: this.newForm})
                this.newForm.splice(index, 2)
            },
            // 试听
            async handleVoiceTry(){
                if(!this.config.per){
                    this.$message.error('您还未选择说话角色')
                    return false
                }
                let index = this.$utils.getIndexByAttr({attr: 'text', data: this.newForm})
                let work=this.textToTTS(this.newForm[index].value);
                // Word2Voice({...this.config, text: this.newForm[index].value})
                // 生成阿里云音频文件
                const res = await GlobalServer.getVoiceByAliyun({
                    work: work,
                    voice: this.config.per,
                    volume: this.config.vol,
                    speech_rate: this.config.spd
                })
                console.log('阿里云res==>', res)
                // 播放试听音频
                if(res.url){
                    AudioPlay({url: res.url})
                }
            },
            async onXunfei(obj){
                this.config = obj
                let selectIndex = this.$utils.getIndexByAttr({attr: 'select', data: this.newForm})
                let name = this.getNameByOptions({id: obj.per, data: this.newForm[selectIndex].options})
                this.newForm[selectIndex].value = name
                // 1.上传ai语音合成 2.关闭ai语音合成
                let textIndex = this.$utils.getIndexByAttr({attr: 'text', data: this.newForm})
                let work=this.textToTTS(this.newForm[textIndex].value);
                const res = await GlobalServer.getVoiceByAliyun({work: work, ...obj})

                if(res.url) {
                    this.config.url = res.url
                    this.uploadAudio({url: res.url, type: 'ai', name: obj.fileName})
                }
            },
            // 将远端地址转成文件流上传
            uploadAudio({url, type, name}) {
                // 将合成音频上传至音频素材
                // 1.将远端地址转成文件流
                // 2.将文件流上传到腾讯云
                // 3.上传合成音频到素材
                getFileStream({url, name, callback: (blob)=>{
                        const bmf = new BMF()
                        bmf.md5(blob, (err, md5)=>{
                            upLoad({isPlat: this.isPlat, fileName: `${md5}.mp3`, file: blob, callback: async url=>{
                                    let newName = type === 'wx'?'微信':'合成'+'音频' + md5.slice(0,3)
                                    if(name) {
                                        newName = name
                                    }
                                    // 上传音频文件到素材列表
                                    let newUrl = this.$utils.getHtmlMd5(url)
                                    const remotepath = url.split('.com/')[1]
                                    let obj = {
                                        clientsId: this.$store.state.initConfig.school_id,
                                        sort: 'audio',
                                        name: newName,
                                        alias: '',
                                        attributes: {
                                            cover: url,
                                            remotepath,
                                            md5: newUrl.indexOf('.') > -1?newUrl.split('.')[0] : newUrl
                                        }
                                    }
                                    if(`${this.categoryId}` !== `0`) obj.categoryId = this.categoryId

                                    const res = await commonServer.default[this.addResource](obj)
                                    if (`${res.status_code}` === '200') {
                                        this.$message.success('上传成功')
                                        this.$refs.roles && this.$refs.roles.handleClose()
                                        // this.$emit('onFlash')
                                    } else {
                                        // this.$message.error('上传失败')
                                    }

                                }})
                        })

                    }})
            },
            getNameByOptions({id, data}){
                let name = ''
                try {
                    data.forEach(v => {
                        if(`${v.key}` === `${id}`) {
                            name = v.value
                        }
                    });
                } catch (e) {
                    console.log('转换失败==>', e)
                }
                return name
            },
            textToTTS(str){
                let arr=str.split("]");//js中的字符串split方法能用正则表达式
                let sarr=[];//当前子字符串
                let ssarr=[];//当前子字符串分割成单个文字
                let nstr="";//转码后文本
                for(let i=0;i<arr.length;i++){
                    sarr=arr[i].split("[");//将[字符转数组
                    ssarr=sarr[0].split('');
                    //console.log("当前字段详情：",sarr);
                    for(let j=0;j<ssarr.length-1;j++){
                        nstr+=ssarr[j];
                        //console.log("当前文字：",nstr);
                    }
                    
                    nstr+=(sarr.length>1)?'<phoneme alphabet="py" ph="'+sarr[1]+'">'+ssarr[ssarr.length-1]+'</phoneme>':((sarr.length==0 || ssarr.length==0)?"":ssarr[ssarr.length-1]);
                }
                console.log("转码后文本","<speak>"+nstr+"</speak>");
                return "<speak>"+nstr+"</speak>";
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>
